import * as React from 'react';
import { attachWrappedComponent } from '../../utils/decoratorUtils/decoratorUtils';
import { requestIdleCallback, cancelIdleCallback } from '../../utils/Timers';

export interface MeasureInputDecoratorProps {
  inputRef: React.RefObject<HTMLInputElement | HTMLTextAreaElement>;
  [key: string]: any; // Allow additional props
}

interface MeasureInputDecoratorState {
  inputWidth: number | null;
}

export default function (Component: React.ComponentType<any>) {
  class MeasureInputDecorator extends React.Component<
    MeasureInputDecoratorProps,
    MeasureInputDecoratorState
  > {
    private _isMounted: boolean;
    private _resizeTimer: any;

    constructor(props: MeasureInputDecoratorProps) {
      super(props);
      this.state = { inputWidth: null };
      this._isMounted = false;
      this._resizeTimer = null;
    }

    componentDidMount() {
      this._isMounted = true;
      window.addEventListener('resize', this.handleWindowResize);
      this.measureInput();
    }

    componentDidUpdate(
      prevProps: MeasureInputDecoratorProps,
      prevState: MeasureInputDecoratorState
    ) {
      if (prevState.inputWidth === this.state.inputWidth) {
        this.measureInput();
      }
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.handleWindowResize);
      cancelIdleCallback(this._resizeTimer);
      this._isMounted = false;
    }

    measureInput = () => {
      if (!this._isMounted) return;
      const inputNode = this.props.inputRef.current;
      if (inputNode) {
        const inputWidth = inputNode.offsetWidth;
        if (inputWidth !== this.state.inputWidth) {
          this.setState({ inputWidth });
        }
      }
    };

    handleWindowResize = () => {
      cancelIdleCallback(this._resizeTimer);
      this._resizeTimer = requestIdleCallback(this.measureInput);
    };

    render() {
      return React.createElement(Component, {
        ...this.props,
        inputWidth: this.state.inputWidth,
      });
    }
  }

  attachWrappedComponent(MeasureInputDecorator, Component);

  return MeasureInputDecorator;
}
